"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputProvider = exports.KHInputSourceType = void 0;
const KHEventHandler_1 = require("../KHEventHandler");
var KHInputSourceType;
(function (KHInputSourceType) {
    KHInputSourceType[KHInputSourceType["Mouse"] = 0] = "Mouse";
    KHInputSourceType[KHInputSourceType["Keyboard"] = 1] = "Keyboard";
    KHInputSourceType[KHInputSourceType["Controller"] = 2] = "Controller";
    KHInputSourceType[KHInputSourceType["Unknown"] = 3] = "Unknown";
})(KHInputSourceType || (exports.KHInputSourceType = KHInputSourceType = {}));
class KHInputProvider {
    static setLastInputSource(provider) {
        if (this.lastInputSource !== provider) {
            this.lastInputSource = provider;
            this.eventHandler.emitEvent("inputSourceUpdated", { inputSource: provider });
        }
    }
    static getLastInputSource() {
        return this.lastInputSource;
    }
    /**
     * Attempt to vibrate the input source.
     * @param duration Duration in millis
     * @param weak Magnitude of weak rumble (0-1)
     * @param strong Magnitude of strong rumble (0-1)
     */
    tryVibrate(duration, weak, strong) {
        // Default is no implementation.
    }
    type() {
        return null;
    }
    getId() {
        return "";
    }
    getInputType() {
        return KHInputSourceType.Unknown;
    }
}
exports.KHInputProvider = KHInputProvider;
KHInputProvider.eventHandler = new KHEventHandler_1.KHEventHandler();
